/* Sève event-tracking layer - single source of truth.
   Tag any control with:
     data-track="<event>" data-track-location="<location>"
     [data-item data-variant data-price]
   Events flow to three sinks: GA4 (existing gtag, G-1ZBHC0QM1Y via the Google
   channel app), Shopify web pixels (Shopify.analytics.publish 'seve_<event>'),
   and window.dataLayer ('seve_<event>'). Clarity records sessions separately.
   NAMING CONTRACT (do not invent new spellings):
   events: add_to_cart select_item begin_checkout email_signup select_pack
           subscribe_toggle quiz_* cta_click
   locations: home_gel_card home_variety home_hero_cta home_sticky_bar
              fuelguide_glycogen_inline fuelguide_plan_cta fuelguide_bottom_cta
              pdp_buybox pdp_select_pack pdp_subscribe_toggle pdp_sticky_atc
              pdp_crosssell cart_drawer_upsell cart_checkout science_verdict_cta
              athletes_cta quiz_result email_signup
              lp_paid_hero lp_paid_mid lp_paid_sticky lp_paid_bottom
              lp_paid_after_numbers lp_paid_after_mechanism lp_paid_after_harvest
              lp_paid_after_compare lp_paid_after_athletes lp_paid_pricing
              lp_paid_callout lp_paid_after_faq */
(function () {
  if (window.shTrackBound) return;
  window.shTrackBound = true;

  var GA_MAP = {
    add_to_cart: 'add_to_cart',
    select_item: 'select_item',
    begin_checkout: 'begin_checkout',
    email_signup: 'sign_up'
  }; // everything else (select_pack, subscribe_toggle, quiz_*, cta_click) -> select_content

  var last = {};

  // capture phase: several buy buttons stopPropagation in their own handlers
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-track]') : null;
    if (!el) return;

    var ev = el.getAttribute('data-track');
    if (!ev) return;
    var payload = {
      event: ev,
      location: el.getAttribute('data-track-location') || '',
      item: el.getAttribute('data-item') || undefined,
      variant: el.getAttribute('data-variant') || undefined,
      price: el.getAttribute('data-price') || undefined,
      page_path: location.pathname
    };

    var key = ev + '|' + payload.location + '|' + (payload.item || '') + '|' + (payload.variant || '');
    var now = Date.now();
    if (last[key] && now - last[key] < 400) return;
    last[key] = now;

    var gaEvent = GA_MAP[ev] || 'select_content';
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', gaEvent, {
          item_id: payload.item,
          item_name: payload.item,
          location: payload.location,
          cta_variant: payload.location,
          purchase_option: payload.variant,
          value: Number(payload.price) || undefined,
          currency: 'CAD',
          page_path: payload.page_path
        });
      }
    } catch (err) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('seve_' + ev, payload);
      }
    } catch (err) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({}, payload, { event: 'seve_' + ev }));
    } catch (err) {}
  }, true);
})();
